
import {AssertUtils} from "goingutils";


export function getCellContainer(ctlId) {
    let cellParent = $("#" + ctlId)
        .closest(".dhx_cell_cont_layout")
        .get(0);
    if (cellParent == null) {
        cellParent = $("#" + ctlId)
            .closest(".ivu-card")
            .get(0);
    }

    if (cellParent == null) {
        cellParent = $("#" + ctlId)
            .parent()
            .get(0);
    }
    return cellParent;
}

let ctlCommonUtils = {
    getPanelTitleHeight(ctlId) {
        let cellParent = getCellContainer(ctlId);
        if (cellParent != null) {
            if (
                $(cellParent)
                    .find(".ivu-card-head")
                    .get(0) != null
            ) {
                return parseFloat(
                    $(cellParent)
                        .find(".ivu-card-head")
                        .css("height")
                );
            }

            if (
                $(cellParent)
                    .find(".dhx_cell_hdr")
                    .get(0) != null
            ) {
                return parseFloat(
                    $(cellParent)
                        .find(".dhx_cell_hdr")
                        .css("height")
                );
            }
        }
        return 35;
    },
    getQueryAreaHeight(ctlId) {
        let cellParent = getCellContainer(ctlId);
        if (cellParent != null) {
            if (
                $(cellParent)
                    .find(".go-form-query")
                    .get(0) != null
            ) {
                return (
                    parseFloat(
                        $(cellParent)
                            .find(".go-form-query")
                            .css("height")
                    ) + 5
                );
            }
        }
        return 150;
    },
    getTabsetHeight(ctlId) {
        let cellParent = getCellContainer(ctlId);
        if (cellParent != null) {
            if (
                $(cellParent)
                    .find(".dhxtabbar_tabs")
                    .get(0) != null
            ) {
                return (
                    parseFloat(
                        $(cellParent)
                            .find(".dhxtabbar_tabs")
                            .css("height")
                    ) + 3
                );
            }
            if (
                $(cellParent)
                    .find(".ivu-tabs-bar")
                    .get(0) != null
            ) {
                return (
                    parseFloat(
                        $(cellParent)
                            .find(".ivu-tabs-bar")
                            .css("height")
                    ) + 3
                );
            }
        }
        return 37;
    },
    getToolBarHeight(ctlId) {
        let cellParent = getCellContainer(ctlId);
        if (cellParent != null) {
            //如果存在用户自定义的工具栏
            if (
                $(cellParent)
                    .find(".go-tool-bar")
                    .get(0) != null
            ) {
                return parseFloat(
                    $(cellParent)
                        .find(".go-tool-bar")
                        .css("height")
                );
            }
            //如果存在dx的工具栏
            if (
                $(cellParent)
                    .find(".dhx_toolbar_material")
                    .get(0) != null
            ) {
                return parseFloat(
                    $(cellParent)
                        .find(".dhx_toolbar_material")
                        .css("height")
                );
            }
        }
        return 35;
    },
    hasPanelTitle(ctlId) {
        let cellParent = getCellContainer(ctlId);
        if (cellParent != null) {
            //如果存在用户自定义的工具栏
            if (
                $(cellParent)
                    .find(".ivu-card-head")
                    .get(0) != null
            ) {
                return true;
            }
            //如果存在子元素 而且申明中包含了 标题
            if (
                $(cellParent)
                    .find(".go-layout-panel")
                    .get(0) != null
            ) {
                if (
                    AssertUtils.isNotEmpty(
                        $(cellParent)
                            .find(".go-layout-panel")
                            .attr("headertext")
                    )
                ) {
                    return true;
                }
            }
            //如果存在用户自定义的工具栏
            if (
                $(cellParent)
                    .find(".dhx_cell_hdr")
                    .get(0) != null
            ) {
                return true;
            }
        }
        return false;
    },
    hasQueryArea(ctlId) {
        //    如果存在查询区域
        let cellParent = getCellContainer(ctlId);
        if (cellParent != null) {
            if (
                $(cellParent)
                    .find(".go-form-query")
                    .get(0) != null
            ) {
                return true;
            }
        }
    },
    hasPagin(ctlId) {
        let cellParent = getCellContainer(ctlId);
        if (cellParent != null) {
            if (
                $(cellParent)
                    .find(".go-pagin-bar")
                    .get(0) != null
            ) {
                return true;
            }
        }
        return false;
    },
    //如果存在Tabset
    hasTabset(ctlId) {
        let cellParent = getCellContainer(ctlId);
        if (cellParent != null) {
            //如果存在用户自定义的工具栏
            if (
                $(cellParent)
                    .find(".dhxtabbar_tabs")
                    .get(0) != null
            ) {
                return true;
            }
            //如果存在用户自定义的工具栏
            if (
                $(cellParent)
                    .find(".ivu-tabs-bar")
                    .get(0) != null
            ) {
                return true;
            }
            //如果存在用户自定义的工具栏
            if (
                $(cellParent)
                    .find(".go_tab_ctl")
                    .get(0) != null
            ) {
                return true;
            }
        }
        return false;
    },
    hasToolBar(ctlId) {
        let cellParent = getCellContainer(ctlId);
        if (cellParent != null) {
            //如果存在用户自定义的工具栏
            if (
                $(cellParent)
                    .find(".go-tool-bar")
                    .get(0) != null
            ) {
                return true;
            }
            //如果存在dx的工具栏
            if (
                $(cellParent)
                    .find(".dhx_toolbar_material")
                    .get(0) != null
            ) {
                return true;
            }
        }
        return false;
    }
};

export default ctlCommonUtils;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/Common_Utils.js